import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { SettingsProvider } from './hooks/useSettings';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import GaragePage from './pages/GaragePage';
import DeadlinePage from './pages/DeadlinePage';
import VehicleFormPage from './pages/VehicleFormPage';
import DocumentPage from './pages/DocumentPage';
import AdminPage from './pages/AdminPage';

function AppContent() {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Caricamento...</div>;
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/garage" element={<GaragePage />} />
      <Route path="/deadline" element={<DeadlinePage />} />
      <Route path="/vehicle/new" element={<VehicleFormPage />} />
      <Route path="/vehicle/:id" element={<VehicleFormPage />} />
      <Route path="/document" element={<DocumentPage />} />
      {profile?.role === 'admin' && <Route path="/admin" element={<AdminPage />} />}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <SettingsProvider>
          <AppContent />
        </SettingsProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
